import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { CommonEpic } from 'common/types';

import exchangeActionTypes from './exchange.actionTypes';
import {
  actionErrorGetExchangeHistory,
  actionErrorGetExchangeSettings,
  actionSuccessGetExchangeHistory,
  actionSuccessGetExchangeSettings,
} from './exchange.actions';
import * as exchangeApi from './exchange.api';

export const epicGetExchangeSettings: CommonEpic<typeof exchangeApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(exchangeActionTypes.LOADING_GET_EXCHANGE_SETTINGS),
    mergeMap(() =>
      from(api.getExchangeSettings()).pipe(
        mergeMap((response) => of(actionSuccessGetExchangeSettings(response))),
        catchError((error) => of(actionErrorGetExchangeSettings(error))),
      ),
    ),
  );

export const epicGetExchangeHistory: CommonEpic<typeof exchangeApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(exchangeActionTypes.LOADING_GET_EXCHANGE_HISTORY),
    mergeMap(() =>
      from(api.getExchangeHistory()).pipe(
        mergeMap((response) => of(actionSuccessGetExchangeHistory(response))),
        catchError((error) => of(actionErrorGetExchangeHistory(error))),
      ),
    ),
  );

export const epicSaveExchangeSettings: CommonEpic<typeof exchangeApi> = (action$, _state$, { api }) =>
  action$.pipe(
    ofType(exchangeActionTypes.SAVE_EXCHANGE_SETTINGS),
    mergeMap((action) =>
      from(api.saveExchangeSettings(action.payload)).pipe(
        mergeMap(() => of(actionSuccessGetExchangeSettings(action.payload))),
        catchError((error) => of(actionErrorGetExchangeSettings(error))),
      ),
    ),
  );
